import * as React from 'react';
import { Eye, EyeOff } from 'lucide-react';

import { cn } from '@/lib/utils';
import { useI18n } from '@/i18n';

export type PasswordInputProps = React.InputHTMLAttributes<HTMLInputElement>;

const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ className, disabled, ...props }, ref) => {
    const { t } = useI18n();
    const [isVisible, setIsVisible] = React.useState(false);

    return (
      <div className="relative w-full">
        <input
          ref={ref}
          type={isVisible ? 'text' : 'password'}
          className={cn('w-full pr-10', className)}
          disabled={disabled}
          {...props}
        />
        <button
          type="button"
          className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 transition hover:text-gray-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary dark:text-gray-400 dark:hover:text-gray-200"
          onClick={() => setIsVisible((prev) => !prev)}
          aria-label={
            isVisible ? t('ui.passwordInput.hidePassword') : t('ui.passwordInput.showPassword')
          }
          disabled={disabled}
        >
          {isVisible ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
        </button>
      </div>
    );
  }
);

PasswordInput.displayName = 'PasswordInput';

export default PasswordInput;
